import type { CapabilityBinding, ModuleMeta } from '../../core/types';
import type { MsFieldKey } from './fields';

export const MS_CAPABILITIES = [
  {
    key: 'base-info',
    pathPrefix: '',
    options: { nameField: 'alias', showNamespace: false },
  },
  {
    key: 'model-subscription-provider',
    pathPrefix: '',
  },
  {
    key: 'model-subscription-other',
    pathPrefix: '',
  },
] as const satisfies readonly CapabilityBinding[];

export const MS_MODULES = [
  {
    key: 'baseInfo',
    title: '基本信息',
    capabilities: [{ key: 'base-info', pathPrefix: '', options: { nameField: 'alias', showNamespace: false } }],
    fields: ['base.name', 'base.description', 'base.workspace'],
    presetCheckFields: ['name'],
  },
  {
    key: 'modelProvider',
    title: '模型供应商',
    capabilities: [{ key: 'model-subscription-provider', pathPrefix: '' }],
    fields: ['ms.strategy', 'ms.billingTotalTokens', 'ms.inputTokens', 'ms.outputTokens'],
    presetCheckFields: ['strategyName'],
    resetFieldPaths: [
      'strategyName',
      'strategyDisplayName',
      'strategyProvider',
      'providerPricing',
      'useSubResourcePricing',
      'billingTotalTokens',
      'inputTokens',
      'outputTokens',
    ],
  },
  {
    key: 'other',
    title: '高级设置',
    capabilities: [{ key: 'model-subscription-other', pathPrefix: '' }],
    fields: ['ms.allowedClientCIDRs', 'ms.allowedClientIPs', 'ms.requests', 'ms.inputTokensValue', 'ms.outputTokensValue'],
    presetCheckFields: ['allowedClientCIDRs', 'allowedClientIPs'],
    resetFieldPaths: [
      'allowedClientCIDRs',
      'allowedClientIPs',
      'requests',
      'inputTokensValue',
      'inputTokensWindowSeconds',
      'outputTokensValue',
      'outputTokensWindowSeconds',
      'switches.showRequests',
      'switches.showInputTokens',
      'switches.showOutputTokens',
    ],
  },
] as const satisfies readonly ModuleMeta<MsFieldKey>[];

export const MS_MODULE_MAP = Object.fromEntries(MS_MODULES.map((item) => [item.key, item]));
